<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/quality/standard/doc/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('biaozhunwendangmingcheng')">
            <el-input v-model="yt.conditions.docName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('wendangleixing')">
            <el-select v-model="yt.conditions.docType">
              <el-option :label="$t('zuoyezhidaoshu')" :value="1"></el-option>
              <el-option :label="$t('guigeshu')" :value="2"></el-option>
              <el-option :label="$t('tudang')" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('jianyanleixing')">
            <el-select v-model="yt.conditions.inspectionType">
              <el-option :label="$t('shoujian')" :value="1"></el-option>
              <el-option :label="$t('choujian')" :value="2"></el-option>
              <el-option :label="$t('mojian')" :value="3"></el-option>
              <el-option :label="$t('chengpinjian')" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"> </yi_data_select>
            <!--            <yi_cross_select multiple :component="'web_base_matter_list'" :ids.sync="yt.conditions.materialIds">-->
            <!--            </yi_cross_select>-->
          </el-form-item>
          <el-form-item :label="$t('gongxumiaoshu')">
            <el-select multiple :clearable="true" v-model="yt.conditions.basicWorkProcedureIds">
              <el-option v-for="(item, index) in processList" :key="index" :label="item.desc" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shifouzuixinban')">
            <el-select v-model="yt.conditions.latest">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('wendangbiaoshi')">
            <yi_dictionary_select :type="'STANDARD_DOC_UPLOAD_FLAG'" :ids.sync="yt.conditions.isUpload"></yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t("sousuo") }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t("chongzhi") }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #wendangbiaoshi="scope">
        <el-tag :type="scope.row.isUpload === '1' ? 'success' : scope.row.isUpload === '0' ? 'danger' : 'warning'" size="mini">
          {{ $t(store.state.dictJsonAll['STANDARD_DOC_UPLOAD_FLAG'][scope.row.isUpload]) }}
        </el-tag> </template>
      <!-- 抽样类型 -->
      <template #jianyanleixing="scope">
        <span v-if="scope.row.inspectionType == 1">{{ $t("shoujian") }}</span>
        <span v-if="scope.row.inspectionType == 2">{{ $t("choujian") }}</span>
        <span v-if="scope.row.inspectionType == 3">{{ $t("mojian") }}</span>
        <span v-if="scope.row.inspectionType == 4">{{ $t("chengpinjian") }}</span>
      </template>
      <!-- 文档类型 -->
      <template #wendangleixing="scope">
        <span v-if="scope.row.docType == 1">{{ $t("zuoyezhidaoshu") }}</span>
        <span v-if="scope.row.docType == 2">{{ $t("guigeshu") }}</span>
        <span v-if="scope.row.docType == 3">{{ $t("tudang") }}</span>
      </template>
      <template #shifouzuixinban="scope">
        <span v-if="scope.row.latest === false">{{ $t("fou") }}</span>
        <span v-if="scope.row.latest === true">{{ $t("shi") }}</span>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="
      yt.showEditDialog('xinzeng', null, 'w1');
    setDefaultValue();
    getProcess();
    " type="primary" v-if="utils.checkPower('web_quality_management_standard_doc_create')">
          {{ $t("xinzeng") }}
        </el-button>
        <el-button size="mini" @click="yt.showEditDialog('daoru', null, '1400px')" v-if="utils.checkPower('web_quality_management_standard_doc_standard_batch_import')" type="primary">
          {{ $t('daoru') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('fuzhi', scope.row)" v-if="utils.checkPower('web_quality_standard_doc_copy')">
              {{ $t("fuzhi") }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('fujian', scope.row, 'w2')" v-if="utils.checkPower('web_quality_management_standard_doc_attach_files_page')">
              {{ $t("fujian") }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.latest === true">
            <el-button type="text" @click="
      yt.showEditDialog('bianji', scope.row);
    getProcess();
    " v-if="utils.checkPower('web_quality_management_standard_doc_update')">
              {{ $t("bianji") }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.latest === true">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/quality/standard/doc/delete')" v-if="utils.checkPower('web_quality_management_standard_doc_delete')">
              {{ $t("shanchu") }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body" @close="closeFn">
      <!-- 新增 -->
      <template v-if="yt.editObj.action == 'fuzhi'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('biaozhunwendangmingcheng')" required>
            <el-input v-model="yt.editObj.docName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('wendangleixing')" required>
            <el-select v-model="yt.editObj.docType">
              <el-option :label="$t('zuoyezhidaoshu')" :value="1"></el-option>
              <el-option :label="$t('guigeshu')" :value="2"></el-option>
              <el-option :label="$t('tudang')" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('jianyanleixing')" required>
            <el-select v-model="yt.editObj.inspectionType">
              <el-option :label="$t('shoujian')" :value="1"></el-option>
              <el-option :label="$t('choujian')" :value="2"></el-option>
              <el-option :label="$t('mojian')" :value="3"></el-option>
              <el-option :label="$t('chengpinjian')" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('chanpinbianma/mingcheng')" required>
            <yi_cross_select :selectTitle="'code,name'" :max="1" :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('gongxumiaoshu')" required>
            <el-select filterable :clearable="true" v-model="yt.editObj.basicWorkProcedureId">
              <el-option v-for="(item, index) in processList" :key="index" :label="item.desc" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/quality/standard/doc/copy')" type="primary">
            {{ $t("baocun") }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('biaozhunwendangmingcheng')" required>
            <el-input v-model="yt.editObj.docName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('wendangleixing')" required>
            <el-select v-model="yt.editObj.docType">
              <el-option :label="$t('zuoyezhidaoshu')" :value="1"></el-option>
              <el-option :label="$t('guigeshu')" :value="2"></el-option>
              <el-option :label="$t('tudang')" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('jianyanleixing')" required>
            <el-select v-model="yt.editObj.inspectionType">
              <el-option :label="$t('shoujian')" :value="1"></el-option>
              <el-option :label="$t('choujian')" :value="2"></el-option>
              <el-option :label="$t('mojian')" :value="3"></el-option>
              <el-option :label="$t('chengpinjian')" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('chanpinbianma/mingcheng')" required>
            <yi_cross_select :selectTitle="'code,name'" :max="1" :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('gongxumiaoshu')" required>
            <el-select filterable :clearable="true" v-model="yt.editObj.basicWorkProcedureId">
              <el-option v-for="(item, index) in processList" :key="index" :label="item.desc" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/quality/standard/doc/create')" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '标准文档-新增标准文档' } }">
            {{ $t("baocun") }}
          </el-button>
        </span>
      </template>
      <!-- 编辑 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('biaozhunwendangmingcheng')" required>
            <el-input v-model="yt.editObj.docName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('wendangleixing')" required>
            <el-select v-model="yt.editObj.docType">
              <el-option :label="$t('zuoyezhidaoshu')" :value="1"></el-option>
              <el-option :label="$t('guigeshu')" :value="2"></el-option>
              <el-option :label="$t('tudang')" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('jianyanleixing')" required>
            <el-select v-model="yt.editObj.inspectionType">
              <el-option :label="$t('shoujian')" :value="1"></el-option>
              <el-option :label="$t('choujian')" :value="2"></el-option>
              <el-option :label="$t('mojian')" :value="3"></el-option>
              <el-option :label="$t('chengpinjian')" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('chanpinbianma/mingcheng')" required>
            <yi_cross_select :selectTitle="'code,name'" :max="1" :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('gongxumiaoshu')" required>
            <el-select filterable :clearable="true" v-model="yt.editObj.basicWorkProcedureId">
              <el-option v-for="(item, index) in processList" :key="index" :label="item.desc" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/quality/standard/doc/update')" type="primary">
            {{ $t("baocun") }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'fujian'">
        <div class="dialog-scroller">
          <appendix :appendix="yt.editObj"></appendix>
        </div>
      </template>
      <template v-if="yt.editObj.action == 'daoru'">
        <div class="dialog-scroller">
          <yi_excel_import ref="cmsPlanOrderImport" @loading-start="startLoading" @loading-stop="stopLoading" :templatekey="'standart_doc_import_template_key'" :uploadApi="'/web/quality/standard/doc/batchImport'" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" size="mini" :loading="mainSubImportLoading" @click="mainSubImportData">{{ $t('baocun') }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import appendix from "./appendix";

export default {
  name: "web_quality_management_standard_doc_standard_list",
  components: {
    appendix,
  },
  data() {
    return {
      processList: [],
      show: false,
      exceptionTypeList: [],
      mainSubImportLoading: false,
      columns: [
        {
          label: "biaozhunwendangmingcheng",
          prop: "docName",
          width: 150,
        },
        {
          label: "wenbenbanban",
          prop: "version",
          width: 130,
        },
        {
          label: "shifouzuixinban",
          // prop: 'isLatest',
          type: "slot",
          width: 130,
        },
        {
          label: "wendangleixing",
          type: "slot",
          width: 130,
        },
        {
          label: "jianyanleixing",
          type: "slot",
        },
        {
          label: "chanpinbianma",
          prop: "material.code",
          width: 130,
        },
        {
          label: "chanpinmingcheng",
          prop: "material.name",
          width: 130,
        },
        {
          label: "gongxumiaoshu",
          prop: "basicWorkProcedure.desc",
          width: 130,
        },
        {
          label: 'wendangbiaoshi',
          prop: 'isUpload',
          type: 'slot',
          width: 100
        },
        {
          label: "chuangjianren",
          prop: "createByObject.nickname",
          width: 130,
        },
        {
          label: "chuangjianshijian",
          prop: "createTime",
          type: "time",
          width: 130,
        },
        {
          label: "caozuo",
          type: "slot",
          width: 150,
          fixed: "right",
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      this.getProcess();
      this.yt.conditions = {
        // orderBy: 'createTime desc,triggerTime asc',
      };
      this.yt.SELECT_URL = "/web/quality/sampling/procedure/listByIds";
      this.yt.SELECT_RESULT_KEY = "data";
      this.yt.SELECT_ID = "id";
      this.yt.SELECT_TITLE = "name";
      this.yt.get(1);
      this.utils.event_hub.$on("WORK_ORDER_REFRESH", () => {
        this.yt.get(1);
      });
    }, 300);
  },

  methods: {
    closeFn() {
      if(this.yt.editObj && this.yt.editObj.action == 'fujian'){
        this.yt.get();
      }
    },
    getProcess() {
      this.http
        .get("/web/craft/basic/work/procedure/page", {
          params: {
            pageNum: 1,
            pageSize: 1000,
          },
        })
        .then((res) => {
          this.processList = res.data.rows;
        });
    },
    setDefaultValue() {
      // this.yt.editObj.samplingType = 1;
      // this.yt.editObj.enabled = true
    },
    startLoading() {
      this.mainSubImportLoading = true;
    },
    stopLoading() {
      this.mainSubImportLoading = false;
    },

    mainSubImportData() {
      let data = [...this.$refs.cmsPlanOrderImport.tableData];
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'));
        return;
      }
      if (this.$refs.cmsPlanOrderImport.listLength == null || this.$refs.cmsPlanOrderImport.listLength.length == 0) {
        this.mainSubImportLoading = true;
        return this.http
          .post('/web/quality/standard/doc/batchImport?onlyValidate=false', data)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get(1);
          })
          .catch(err => {
            this.utils.errorMessage(this.$t(err));
          })
          .finally(() => {
            this.mainSubImportLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
      }
    },
  },
};
</script>
